export const CONFIGURATION_LOADED = "CONFIGURATION_LOADED";
export const UPDATE_OVERLAY_IMAGE = "UPDATE_OVERLAY_IMAGE";

export const ACTIVATE_ITEM = "ACTIVATE_ITEM";
export const CONFIGURATION_CHANGED = "CONFIGURATION_CHANGED";
export const ACTIVATE_MASK_ITEM = "ACTIVATE_MASK_ITEM";
export const ACTIVATE_BY_ARTICLE_NUMBER = "ACTIVATE_BY_ARTICLE_NUMBER";
export const RELOAD_CONFIGURATION = "RELOAD_CONFIGURATION";
export const SET_MENU_CACHE = "SET_MENU_CACHE";
export const SET_SUMMARIES = "SET_SUMMARIES";
export const SET_ACTIVE_MENU_PATH = "SET_ACTIVE_MENU_PATH";
export const SET_TOTAL_PRICE = "SET_TOTAL_PRICE";
export const SET_SURFACE_PATTERN = "SET_SURFACE_PATTERN";
export const SET_LAYOUT_GROUPS = "SET_LAYOUT_GROUPS";
export const SET_ACTIVE_LAYOUT_GROUP = "SET_ACTIVE_LAYOUT_GROUP";
export const ACTIVATE_SURFACE_LAYOUTS = "ACTIVATE_SURFACE_LAYOUTS";
export const ACTIVATE_FAVORITE = "ACTIVATE_FAVORITE";
export const SURFACE_PATTERN_CHANGED = "SURFACE_PATTERN_CHANGED";
export const SET_FAVORITE_OVERLAY_ACTIVE = "SET_FAVORITE_OVERLAY_ACTIVE";
export const SET_LAYOUT_OVERLAY_ACTIVE = "SET_LAYOUT_OVERLAY_ACTIVE";
